import {FC} from 'react';
import {ProcessDiagramIds} from '../../../../constants/tasks';

const TaskRowEnd: FC = () => (
  <div className="task-row-elements_end" id={ProcessDiagramIds.END} />
);

export default TaskRowEnd;
